import {
  GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILED
} from "../actions/products_actions";

const initialState = {
  products: [],
}

export const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS_REQUEST: {
      return {
        ...state,
      }
    }
    case GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        products: action.products,
      }
    }
    case GET_PRODUCTS_FAILED: {
      return {
        ...state,
      }
    }
    default: return state
  }
}
